/**
 * @license
 * Copyright 2025 VICO
 */

import 'bootstrap';
import 'simplebar';
import 'magic.css/dist/magic.min.css';
import 'simplebar/dist/simplebar.min.css';
import "simple-datatables/dist/style.css";
import 'mobius1-selectr/dist/selectr.min.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
import 'line-awesome/dist/line-awesome/css/line-awesome.min.css';


// import _ from 'lodash';
// import ApexCharts from 'apexcharts';

import './styles/bootstrap.css'
import './fonts/fonts.css';
import './styles/app.css';
import './index.css';

import { initializeApp } from "./scripts/bootstrap.js";
import {DynamicSelect} from "./scripts/dynamicSelect";
import {initLoginPage} from "./scripts/login";
import {initRegisterPage} from "./scripts/register";
import {initForgetPage} from "./scripts/forget";

import { initMainLayout } from './scripts/layout.js';
import { initRouter } from './scripts/router.js';
import topBarHtml from "./modules/topbar.html";
import sideBarHtml from "./modules/sidebar.html";
import {generateMenuItem} from "./scripts/sidebarGenerator";

const PUBLIC_PAGES = ['/', '/login', '/register', '/forget'];

function main() {
    initializeApp();

    const currentPath = window.location.pathname.replace(/\/index\.html$/, '').replace(/\/$/, '') || '/';
    const isInternalPage = !PUBLIC_PAGES.includes(currentPath);

    document.querySelectorAll('[data-dynamic-select]').forEach(select => new DynamicSelect(select));

    if (isInternalPage) {
        const appContainer = document.getElementById("app");
        if (appContainer) {
            appContainer.innerHTML = topBarHtml.trim() + sideBarHtml.trim() + appContainer.innerHTML;
        }
        const menuContainer = document.getElementById("sidebar-menu-container");
        if (menuContainer) {
            menuContainer.innerHTML = generateMenuItem();
        }

        initMainLayout().then();
        initRouter();

    } else {
        initLoginPage();
        initRegisterPage();
        initForgetPage();
    }
}

document.addEventListener('DOMContentLoaded', main);
